import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCalendarPlus, faListCheck } from '@fortawesome/free-solid-svg-icons';
import { getGameColor } from '../data/objects/gameColor';
import { useDarkMode } from '../contexts/DarkModeContext';
import { Product } from '../data/interfaces/Product';
import { Variation } from '../data/interfaces/Variation';

interface ProductCardProps {
    id: number;
    title: string;
    slug: string;
    description: string;
    thumbnailUrl: string;
    version: string;
    datePosted: string;
    dateUpdated: string;
    game: string;
    tags: string[];
    isAddonCard?: boolean;
    linkedProduct?: Product;
    linkedVariation?: Variation;
}

const ProductCard: React.FC<ProductCardProps> = ({ id, title, slug, description, thumbnailUrl, version, datePosted, dateUpdated, game, isAddonCard, linkedProduct, linkedVariation }) => {
    const gameColor = getGameColor(game);
    const { isDarkMode } = useDarkMode();

    const getCardLink = (): string => {
        if (isAddonCard) { //isAddonCard && linkedProduct && linkedVariation
            return `/addons/${slug}`;
        }
        return `/works/${slug}`;
    };

    return (
        <div className={`col-lg-3 col-6 d-flex align-items-stretch ${isAddonCard ? 'my-2' : 'mb-3'}`}>
            <Link to={getCardLink()} className="card-link" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className={`card d-flex flex-column ${isDarkMode ? 'dark-mode-2' : 'light-mode-2'}`} style={{ width: '100%', height: '100%' }}>
                    <img src={thumbnailUrl} className="card-img-top" alt={title} />
                    <div className="card-body d-flex flex-column justify-content-between">
                        <div>
                            <h5 className="card-title kanit-regular">{title}</h5>

                            <div className="d-flex align-items-center">
                                <div
                                    className="game-indicator"
                                    style={{
                                        backgroundColor: gameColor
                                    }}
                                ></div>
                                <p className="card-text m-0 kanit-regular" style={{ color: 'gray' }}>{game}</p>
                            </div>


                            {isAddonCard && (
                                <div className="d-flex align-items-center">
                                    <div
                                        className="addon-indicator"
                                        style={{
                                            backgroundColor: gameColor
                                        }}
                                    ></div>
                                    <p className="card-text m-0">Add-on</p>
                                </div>
                            )}

                            {/* Version Section */}
                            <div className="version-info mt-4 kanit-light-italic">
                                <FontAwesomeIcon icon={faListCheck} />
                                <span>Version {version}</span>
                            </div>

                            {/* Date Section */}
                            <div className="dates-info kanit-light-italic">
                                <FontAwesomeIcon icon={faCalendarDays} />
                                <span>Posted: {datePosted}</span>
                            </div>

                            {dateUpdated && (
                                <div className="dates-info kanit-light-italic">
                                    <FontAwesomeIcon icon={faCalendarPlus} />
                                    <span>Updated: {dateUpdated}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default ProductCard;
